export default __webpack_public_path__ + "static/media/client4.d37dc4bb.avif";